import {
  WebSocketEvent,
  WebSocketEventData,
} from "../Models/WebSocketEventData";
import { useChecklistStore } from "../Stores/Checklist";
import { useFrontendToolStore } from "../Stores/FrontendTools";
import { useKaiVoiceStore } from "../Stores/KaiVoice";
import { useTicketStore } from "../Stores/Ticket";

export const handleWebSocketEvent = (
  event: string,
  data: WebSocketEventData
) => {
  // Send event to target
  switch (event) {
    case WebSocketEvent.BUG_TYPING:
    case WebSocketEvent.BUG_UPDATED:
    case WebSocketEvent.BUG_CREATED:
    case WebSocketEvent.MESSAGE_CREATED:
    case WebSocketEvent.MESSAGE_DELETED:
    case WebSocketEvent.MESSAGE_UPDATED:
      useTicketStore.getState().handleWebSocketEvent(data);
      break;

    // A voice call's open_page push carries the call id: the widget session is
    // shared by every tab of the origin (same localStorage), so every tab gets
    // the event — only the tab running the call may open the page.
    case WebSocketEvent.BOT_OPENLINK: {
      const voiceCallId = data?.actionData?.voiceCallId;
      if (voiceCallId) {
        const voice = useKaiVoiceStore.getState();
        if (voice.callId !== voiceCallId && voice.pendingCallId !== voiceCallId) break;
      }
      useTicketStore.getState().handleWebSocketEvent(data);
      break;
    }

    case WebSocketEvent.BOT_OPENTICKET:
    case WebSocketEvent.BOT_WRITTING:
    case WebSocketEvent.BOT_TOOL:
    case WebSocketEvent.BOT_STARTFEEDBACKFLOW:
    case WebSocketEvent.CUSTOMACTION_RUN:
      useTicketStore.getState().handleWebSocketEvent(data);
      break;

    case WebSocketEvent.CHECKLIST_UPDATED:
      useChecklistStore.getState().handleWebSocketEvent(data);
      break;

    // Frontend tool execution request — the agent wants a
    // Gleap.registerAgentTool handler to run in the host app.
    case WebSocketEvent.BOT_TOOL_EXECUTE:
      useFrontendToolStore.getState().handleExecutionRequest(data.actionData);
      break;

    // The server ended the voice call (action handoff, human handoff, cap) —
    // hang up the WebRTC session so the overlay actually closes.
    case WebSocketEvent.VOICE_CALL_ENDED:
      useKaiVoiceStore.getState().handleServerEnded(data.actionData);
      break;

    // Kai's answer text for the current turn (accumulated per spoken
    // sentence) — the overlay caption shows the answer, never GPT-Live's
    // own acknowledgements.
    case WebSocketEvent.VOICE_CAPTION:
      useKaiVoiceStore.getState().handleCaption(data.actionData);
      break;

    // Kai Resolve is working on the request: the call is on hold (hold music).
    case WebSocketEvent.VOICE_HOLD:
      useKaiVoiceStore.getState().handleHold(data.actionData);
      break;

    default:
      break;
  }
};
